import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ApiStatusPageComponent } from './components/api-status-page/api-status-page.component';

@Component({
  standalone: true,
  imports: [RouterModule, ApiStatusPageComponent],
  selector: 'fin-status-page-app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
